import margaeryPic from "@/public/images/artists/margaery.png";
import { Artist } from "@/types/types";

export const margaery = {
  id: "151",
  name: "Margaery",
  image: margaeryPic,
  description: `Margaery commands a beautifully clear alto voice. Her tone is rich and subtly expressive, effortlessly evoking both depth and grace.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmargaery-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Classical", "Mature", "Falsetto"],
      secondary: ["Alto"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 56,
        high: 78,
      },
      sweetSpot: 67,
    },
  },
} as const satisfies Artist;
